<template>
  <div v-if="!cannotGrade" class="pb-6">
    <h3 class="flex items-center">
      {{ upperFirst(assessmentDetails.competition.grading_status) }} Grade
      <popper
        trigger="click"
        :options="{
          placement: 'bottom'
        }"
        @show="toggleFocusInput(`textarea_${question.key}`, true)"
        @hide="toggleFocusInput(`textarea_${question.key}`)"
      >
        <div
          class="text-base bg-white shadow-lg p-4 z-100 absolute w-64 border-t-4 border-grey-500"
          :class="[
            gradingColor(
              assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
                .grade,
              'border'
            )
          ]"
        >
          <span
            class="absolute leading-none -mb-px text-xs"
            style="left: 50%; bottom:100%; transform: translateX(-50%)"
            :class="[
              gradingColor(
                assessmentDetails.grading[`${gradingStatus}_grades`][
                  question.key
                ].grade,
                'text'
              )
            ]"
          >
            ▲
          </span>
          <label
            :for="`${question.key}_note`"
            class="text-xs font-bold block text-grey-700 mb-1"
          >
            Notes
          </label>
          <textarea
            :id="`${question.key}_note`"
            :ref="`textarea_${question.key}`"
            :name="`${question.key}_note`"
            :value="
              assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
                .note
            "
            :placeholder="`Please enter your notes for this question's grade`"
            :disabled="isLocked"
            class="focus:outline-none w-full leading-normal text-grey-600 focus:text-black transition-all transition-normal h-32 resize-none p-0"
            @blur="
              assessmentDetails.grading[`${gradingStatus}_grades`][
                question.key
              ].note = $event.target.value
            "
          />
        </div>
        <button
          slot="reference"
          type="button"
          class="flex items-center p-3 focus:outline-none"
          :class="{
            'opacity-0 cursor-default':
              assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
                .grade === 0
          }"
          :disabled="
            assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
              .grade === 0
          "
        >
          <icon
            icon="chat"
            class="w-6 h-6"
            :class="{
              'icons-primary':
                assessmentDetails.grading[`${gradingStatus}_grades`][
                  question.key
                ].note,
              'icons-grey': !assessmentDetails.grading[
                `${gradingStatus}_grades`
              ].note
            }"
          />
        </button>
      </popper>
    </h3>
    <template v-if="gradingStatus === 'interview'">
      <p>
        Initial Grade:
        <b
          :class="
            gradingColor(
              assessmentDetails.grading.initial_grades[question.key].grade,
              'text'
            )
          "
        >
          {{ assessmentDetails.grading.initial_grades[question.key].grade }}
        </b>
      </p>
    </template>
    <div class="flex flex-wrap -mx-px">
      <label
        v-for="gradeMark in gradeRange"
        :key="gradeMark"
        :for="`${question.key}_mark_${gradeMark + 1}`"
        class="flex cursor-pointer w-1/5 h-12 p-px"
        tabindex="0"
        @keydown.enter="
          $set(
            assessmentDetails.grading[`${gradingStatus}_grades`][question.key],
            'grade',
            gradeMark + 1
          )
        "
      >
        <input
          :id="`${question.key}_mark_${gradeMark + 1}`"
          v-model="
            assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
              .grade
          "
          type="radio"
          :name="`${question.key}_mark`"
          :value="gradeMark + 1"
          class="hidden"
          :disabled="isLocked"
        />
        <div
          class="flex-1 m-px flex items-center justify-center transition-all transition-normal"
          :class="[
            isActive(
              assessmentDetails.grading[`${gradingStatus}_grades`][question.key]
                .grade ===
                gradeMark + 1
            ),
            gradingColor(gradeMark + 1),
            {
              'hover:opacity-100': !isLocked,
              'cursor-not-allowed': isLocked
            }
          ]"
        >
          <span class="font-bold text-white">{{ gradeMark + 1 }}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import upperFirst from "lodash/upperFirst";
import { gradingColourMixin } from "../mixins/gradingColour";
export default {
  name: "ApplicationInlineGrading",
  inject: ["assessmentDetails"],
  components: { Popper },
  mixins: [gradingColourMixin],
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    gradingStatus() {
      return this.assessmentDetails.competition.grading_status;
    },
    gradeRange() {
      return Array.apply(null, { length: 10 }).map(Number.call, Number);
    },
    gradingSet() {
      return {
        grades:
          this.gradingStatus === "interview" && !this.cannotGrade
            ? this.assessmentDetails.grading?.interview_grades
            : this.assessmentDetails.grading?.initial_grades,
        original:
          this.gradingStatus === "interview" && !this.cannotGrade
            ? this.assessmentDetails.grading?.initial_grades
            : false
      };
    },
    cannotGrade() {
      return (
        this.assessmentDetails.competition.rejected_at &&
        this.assessmentDetails.competition.initial_notified_at &&
        !this.assessmentDetails.competition.interview_notified_at
      );
    },
    isLocked() {
      return (
        Boolean(
          this.assessmentDetails.competition.funding_pots[0].grading_locked
        ) ||
        this.assessmentDetails.project.rejected_at !== null ||
        this.assessmentDetails.project.withdrawn_at !== null ||
        this.assessmentDetails.project.shortlisted_at !== null ||
        this.assessmentDetails.project.awarded_at !== null
      );
    }
  },
  methods: {
    upperFirst,
    toggleFocusInput(ref, focus = false) {
      if (focus) {
        setTimeout(() => this.$refs[ref].focus(), 50);
      }
      this.$refs[ref].blur();
    },
    isActive(value) {
      return value ? "opacity-100" : "opacity-25";
    }
  }
};
</script>
